/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { WardrobeItem } from './types';

// Default wardrobe items (Original items optimized for Try-On + Expanded Catalog)
// Default wardrobe items (Empty as requested)
export const defaultWardrobe: WardrobeItem[] = [];
